// export const SERVER_URL = "http://localhost:1337";
// export const SERVER_URL = "https://e02a-2405-9800-ba00-de0e-688a-e086-6d44-7773.ngrok.io";
// export const SERVER_URL = "http://159.223.34.186:1337";
export const SERVER_URL = "https://api.bioeducationalgame.com";